// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-leng-container {
    position: relative;
}

.select-with-flags {
    display: flex;
    width: 132px; 
    padding: 5px;
    font-size: 16px;
    position: absolute;
    height: 80px;
    background-color: white;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 1;
    right: -27px;
    top: 41px;
    border-radius: 4px;
}

.flag-option {
    display: flex;
    align-items: center;
    width: 79px;
    height: 20px;
    margin-bottom: 13px;
    position: relative;
}

.flag-option:hover::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    background-color: #373D43; /* Puedes cambiar el color del subrayado aquí */
    bottom: -2px;
    left: 0;
}

.selected {
    color: #373D43;
    height: 20px;
    margin: auto 0px;
    font-weight: bold;
}

.flag-icon {
    width: 24px;
    height: 16px;
    margin-right: 5px;
}

.selected-lang-option {
    margin: auto 0px;
    position: relative;
    height: 20px;
    width: 72px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 22px;
}

.flag-arrow  {
    margin-left: auto;
    transition: transform 0.3s;
}

.flag-arrow.rotate {
    transform: rotate(180deg);
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomSelectFlags/SelectWithFlags.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,yBAAyB,EAAE,+CAA+C;IAC1E,YAAY;IACZ,OAAO;AACX;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".select-leng-container {\n    position: relative;\n}\n\n.select-with-flags {\n    display: flex;\n    width: 132px; \n    padding: 5px;\n    font-size: 16px;\n    position: absolute;\n    height: 80px;\n    background-color: white;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    z-index: 1;\n    right: -27px;\n    top: 41px;\n    border-radius: 4px;\n}\n\n.flag-option {\n    display: flex;\n    align-items: center;\n    width: 79px;\n    height: 20px;\n    margin-bottom: 13px;\n    position: relative;\n}\n\n.flag-option:hover::after {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 2px;\n    background-color: #373D43; /* Puedes cambiar el color del subrayado aquí */\n    bottom: -2px;\n    left: 0;\n}\n\n.selected {\n    color: #373D43;\n    height: 20px;\n    margin: auto 0px;\n    font-weight: bold;\n}\n\n.flag-icon {\n    width: 24px;\n    height: 16px;\n    margin-right: 5px;\n}\n\n.selected-lang-option {\n    margin: auto 0px;\n    position: relative;\n    height: 20px;\n    width: 72px;\n    font-weight: bold;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-right: 22px;\n}\n\n.flag-arrow  {\n    margin-left: auto;\n    transition: transform 0.3s;\n}\n\n.flag-arrow.rotate {\n    transform: rotate(180deg);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
